import styled, { css } from 'styled-components';

export const Place = styled.div`
  margin: 6px 0 0;
  padding: 2px 0;
  position: relative;
  color: #e6eaec;
  ${(props) =>
    props.loading &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: -4px;
        left: -4px;
        width: calc(100% + 8px);
        height: calc(100% + 8px);
        border-radius: 8px;
        background: rgba(14, 21, 24, 0.72) url('/images/loader.svg') no-repeat 50% 50%;
        background-size: 26px auto;
      }
    `}
`;
export const PlaceItem = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    margin: 0 0 0 10px;
    font-size: 13px;
    color: #e6eaec;
  }
  input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    box-sizing: border-box;
    cursor: pointer;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    border: 1px solid #3d4952;
    border-radius: 5px;
    background: #10151a;
    transition: background 0.15s ease, border-color 0.15s ease;
    &:hover {
      border-color: #4a5762;
    }
    &:checked {
      background-color: #47b972;
      border-color: #47b972;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6L9 17l-5-5'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 12px;
    }
  }
`;
